export default __webpack_public_path__ + "static/media/PopupIcons_View_Transaction_Grey.7e024cbd.svg";